(function () {
  var appearanceStorageKey = 'fmvAppearanceMode';
  var wishlistStorageKey = 'fmvWishlist';
  var modeClasses = ['fmv-mode-light', 'fmv-mode-dark', 'fmv-mode-system'];
  var mediaQuery = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

  function getConfiguredAppearanceMode() {
    try {
      var storedMode = localStorage.getItem(appearanceStorageKey);
      if (['light', 'dark', 'system'].indexOf(storedMode) > -1) return storedMode;
    } catch (error) {
      // Storage can be unavailable in strict privacy contexts.
    }

    var configuredMode = window.FMV_THEME && window.FMV_THEME.appearanceMode;
    var bodyMode = document.body && document.body.dataset.fmvAppearance;
    var mode = configuredMode || bodyMode || 'dark';

    return ['light', 'dark', 'system'].indexOf(mode) > -1 ? mode : 'dark';
  }

  function updateAppearanceToggleLabels(mode) {
    document.querySelectorAll('[data-fmv-theme-toggle]').forEach(function (toggle) {
      var label = toggle.querySelector('[data-fmv-theme-label]');
      toggle.setAttribute('aria-label', 'Theme mode: ' + mode);
      toggle.setAttribute('title', 'Theme mode: ' + mode);
      if (label) label.textContent = mode.charAt(0).toUpperCase() + mode.slice(1);
    });
  }

  function applyAppearanceMode(mode) {
    if (!document.body) return;

    modeClasses.forEach(function (className) {
      document.body.classList.remove(className);
    });

    document.body.classList.add('fmv-mode-' + mode);
    document.body.dataset.fmvAppearance = mode;
    document.documentElement.dataset.fmvAppearance = mode;
    document.documentElement.dataset.fmvResolvedAppearance = mode === 'system' && mediaQuery
      ? (mediaQuery.matches ? 'dark' : 'light')
      : mode;
    updateAppearanceToggleLabels(mode);

    try {
      localStorage.setItem(appearanceStorageKey, mode);
    } catch (error) {
      // Storage can be unavailable in strict privacy contexts.
    }
  }

  function initAppearanceMode() {
    applyAppearanceMode(getConfiguredAppearanceMode());
  }

  function padCountdownValue(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdowns(root) {
    var scope = root || document;
    var countdowns = scope.querySelectorAll('[data-fmv-countdown]');

    countdowns.forEach(function (countdown) {
      if (countdown.dataset.fmvCountdownReady === 'true') return;
      countdown.dataset.fmvCountdownReady = 'true';

      var endDate = Date.parse(countdown.dataset.endDate || '');
      var expiredMessage = countdown.dataset.expiredMessage || 'This limited drop has ended.';
      var daysEl = countdown.querySelector('[data-fmv-countdown-days]');
      var hoursEl = countdown.querySelector('[data-fmv-countdown-hours]');
      var minutesEl = countdown.querySelector('[data-fmv-countdown-minutes]');
      var secondsEl = countdown.querySelector('[data-fmv-countdown-seconds]');
      var messageEl = countdown.querySelector('[data-fmv-countdown-message]');
      var units = [daysEl, hoursEl, minutesEl, secondsEl];

      function expire() {
        units.forEach(function (unit) {
          if (unit) unit.textContent = '00';
        });

        if (messageEl) {
          messageEl.textContent = expiredMessage;
          messageEl.hidden = false;
        }
      }

      function updateCountdown() {
        var remaining = endDate - Date.now();

        if (!Number.isFinite(endDate) || remaining <= 0) {
          expire();
          return false;
        }

        var totalSeconds = Math.floor(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (daysEl) daysEl.textContent = padCountdownValue(days);
        if (hoursEl) hoursEl.textContent = padCountdownValue(hours);
        if (minutesEl) minutesEl.textContent = padCountdownValue(minutes);
        if (secondsEl) secondsEl.textContent = padCountdownValue(seconds);
        if (messageEl) messageEl.hidden = true;

        return true;
      }

      if (updateCountdown()) {
        var interval = window.setInterval(function () {
          if (!updateCountdown()) window.clearInterval(interval);
        }, 1000);
      }
    });
  }

  function initHeroSliders(root) {
    var scope = root || document;
    var editorialHeroes = scope.querySelectorAll('[data-fmv-hero-editorial]');

    editorialHeroes.forEach(function (hero) {
      if (hero.dataset.fmvHeroReady === 'true') return;
      hero.dataset.fmvHeroReady = 'true';

      var texts = hero.querySelectorAll('[data-fmv-hero-text]');
      if (texts.length < 2) return;
      var activeIndex = 0;

      function setText(index) {
        activeIndex = index % texts.length;
        texts.forEach(function (text, textIndex) {
          text.classList.toggle('is-active', textIndex === activeIndex);
          text.setAttribute('aria-hidden', String(textIndex !== activeIndex));
        });
      }

      setText(0);
      window.setInterval(function () {
        setText(activeIndex + 1);
      }, 5200);
    });

    var sliders = scope.querySelectorAll('[data-fmv-hero-slider]');

    sliders.forEach(function (slider) {
      if (slider.dataset.fmvSliderReady === 'true') return;
      slider.dataset.fmvSliderReady = 'true';

      var slides = slider.querySelectorAll('[data-fmv-hero-slide]');
      if (slides.length < 2) return;

      var activeIndex = 0;

      function setSlide(index) {
        activeIndex = index % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
      }

      setSlide(0);
      window.setInterval(function () {
        setSlide(activeIndex + 1);
      }, 5600);
    });
  }

  function initRevealAnimations(root) {
    var scope = root || document;
    var revealItems = scope.querySelectorAll('.fmv-section, .fmv-product-card, .fmv-account-card, .fmv-auth__card, .fmv-trust-item, [data-fmv-story-reveal]');

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16 });

    revealItems.forEach(function (item) {
      if (item.classList.contains('is-visible')) return;
      item.classList.add('fmv-reveal');
      observer.observe(item);
    });
  }

  function getNextAppearanceMode(mode) {
    if (mode === 'dark') return 'light';
    if (mode === 'light') return 'system';
    return 'dark';
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(wishlistStorageKey, JSON.stringify(items));
    } catch (error) {
      return;
    }
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-fmv-wishlist-count]').forEach(function (item) {
      item.textContent = String(count);
      item.hidden = count === 0;
    });
    document.querySelectorAll('[data-fmv-wishlist-toggle]').forEach(function (button) {
      var id = button.dataset.productId;
      var active = getWishlist().some(function (item) { return item.id === id; });
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  function renderWishlist() {
    var container = document.querySelector('[data-fmv-wishlist-items]');
    if (!container) return;
    var items = getWishlist();

    if (!items.length) {
      container.innerHTML = '<div class="fmv-empty"><h2>Your Vault is empty.</h2><p>Save your favorite movie merch here and come back anytime.</p><a class="fmv-btn fmv-btn--full" href="/collections/all">Continue Shopping</a></div>';
      return;
    }

    container.innerHTML = items.map(function (item) {
      var image = item.image ? '<img src="' + escapeHTML(item.image) + '" alt="">' : '';
      var moveButton = item.variantId ? '<button class="fmv-btn fmv-btn--full" type="button" data-fmv-wishlist-cart="' + escapeHTML(item.variantId) + '">Move to Cart</button>' : '';
      return '<article class="fmv-wishlist-item" data-wishlist-id="' + escapeHTML(item.id) + '">' +
        image +
        '<div><h3>' + escapeHTML(item.title) + '</h3><p>' + escapeHTML(item.price) + '</p><a class="fmv-btn fmv-btn--secondary fmv-btn--full" href="' + escapeHTML(item.url) + '">View Product</a>' + moveButton + '<button class="fmv-auth__link" type="button" data-fmv-wishlist-remove="' + escapeHTML(item.id) + '">Remove</button></div>' +
      '</article>';
    }).join('');
  }

  function toggleWishlist(button) {
    var id = button.dataset.productId;
    if (!id) return;
    var items = getWishlist();
    var existingIndex = items.findIndex(function (item) { return item.id === id; });

    if (existingIndex > -1) {
      items.splice(existingIndex, 1);
    } else {
      items.push({
        id: id,
        variantId: button.dataset.variantId || '',
        title: button.dataset.productTitle || 'Movie merch',
        url: button.dataset.productUrl || '#',
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
    }

    saveWishlist(items);
    updateWishlistCount();
    renderWishlist();
  }

  function openPanel(panel, overlay) {
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
      overlay.classList.add('is-open');
    }
    document.body.classList.add('fmv-drawer-open');
  }

  function closePanels() {
    document.querySelectorAll('[data-fmv-mobile-panel], [data-fmv-wishlist-drawer]').forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-fmv-menu-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    var overlay = document.querySelector('[data-fmv-drawer-overlay]');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
    }
    document.body.classList.remove('fmv-drawer-open');
  }

  function openMobileMenu(toggle) {
    var panel = document.querySelector('[data-fmv-mobile-panel]');
    var overlay = document.querySelector('[data-fmv-drawer-overlay]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    openPanel(panel, overlay);
  }

  function openWishlist() {
    renderWishlist();
    openPanel(document.querySelector('[data-fmv-wishlist-drawer]'), document.querySelector('[data-fmv-drawer-overlay]'));
  }

  function initProductForms(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fmv-product-form]').forEach(function (form) {
      if (form.dataset.fmvProductReady === 'true') return;
      form.dataset.fmvProductReady = 'true';
    });
  }

  function initProductGalleries(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fmv-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.fmvGalleryReady === 'true') return;
      gallery.dataset.fmvGalleryReady = 'true';
      setGalleryIndex(gallery, 0);
      var touchStartX = 0;
      var stage = gallery.querySelector('[data-fmv-product-gallery-stage]');
      if (stage) {
        stage.addEventListener('touchstart', function (event) {
          touchStartX = event.changedTouches && event.changedTouches.length ? event.changedTouches[0].clientX : 0;
        }, { passive: true });
        stage.addEventListener('touchend', function (event) {
          if (!touchStartX || !event.changedTouches || !event.changedTouches.length) return;
          var distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 40) return;
          setGalleryIndex(gallery, Number(gallery.dataset.activeIndex || 0) + (distance < 0 ? 1 : -1));
          touchStartX = 0;
        }, { passive: true });
      }
    });
  }

  function setGalleryIndex(gallery, index) {
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-fmv-gallery-item]'));
    var thumbs = gallery.querySelectorAll('[data-fmv-gallery-thumb]');
    if (!items.length) return;
    var activeIndex = ((index % items.length) + items.length) % items.length;
    var prevIndex = (activeIndex - 1 + items.length) % items.length;
    var nextIndex = (activeIndex + 1) % items.length;

    gallery.dataset.activeIndex = String(activeIndex);
    items.forEach(function (item, itemIndex) {
      item.classList.toggle('is-active', itemIndex === activeIndex);
      item.classList.toggle('is-prev', items.length > 1 && itemIndex === prevIndex);
      item.classList.toggle('is-next', items.length > 1 && itemIndex === nextIndex);
      item.setAttribute('aria-hidden', String(itemIndex !== activeIndex));
    });

    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', Number(thumb.dataset.galleryIndex) === activeIndex);
    });
  }

  function syncVariantState(input) {
    var form = input.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput) idInput.value = input.value;

    document.querySelectorAll('[data-fmv-sticky-form] [name="id"]').forEach(function (stickyInput) {
      stickyInput.value = input.value;
    });

    var addButton = form && form.querySelector('[data-fmv-add-button]');
    var available = !input.disabled;
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    var selectedLabel = document.querySelector('label[for="' + input.id + '"]');
    var availability = document.querySelector('[data-fmv-product-availability]');
    if (availability) availability.textContent = available ? 'In stock and ready for the vault.' : 'Currently sold out.';

    var price = document.querySelector('[data-fmv-product-price]');
    if (price && input.dataset.variantPrice) {
      var compare = input.dataset.variantHasCompare === 'true' && input.dataset.variantCompare
        ? '<s>' + escapeHTML(input.dataset.variantCompare) + '</s>'
        : '';
      price.innerHTML = '<div class="fmv-price"><span>' + escapeHTML(input.dataset.variantPrice) + '</span>' + compare + '</div>';
    }

    document.querySelectorAll('[data-fmv-wishlist-toggle][data-variant-id]').forEach(function (button) {
      button.dataset.variantId = input.value;
      if (input.dataset.variantPrice) button.dataset.productPrice = input.dataset.variantPrice;
    });

    document.querySelectorAll('[data-fmv-sticky-form] button').forEach(function (button) {
      button.disabled = !available;
      button.textContent = available ? 'Add to cart - ' + (input.dataset.variantPrice || (selectedLabel && selectedLabel.textContent.replace(' - Sold out', '')) || '') : 'Sold out';
    });
  }

  function syncQuantityState(input) {
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var value = parseInt(input.value || String(min), 10);
    if (Number.isNaN(value) || value < min) value = min;
    input.value = value;

    document.querySelectorAll('[data-fmv-sticky-quantity]').forEach(function (stickyInput) {
      stickyInput.value = String(value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAppearanceMode();
      initCountdowns();
      initHeroSliders();
      initRevealAnimations();
      initProductForms();
      initProductGalleries();
      updateWishlistCount();
      renderWishlist();
    });
  } else {
    initAppearanceMode();
    initCountdowns();
    initHeroSliders();
    initRevealAnimations();
    initProductForms();
    initProductGalleries();
    updateWishlistCount();
    renderWishlist();
  }

  if (mediaQuery) {
    var handleSystemChange = function () {
      if ((document.body && document.body.dataset.fmvAppearance) === 'system') {
        applyAppearanceMode('system');
      }
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleSystemChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleSystemChange);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCountdowns(event.target);
    initHeroSliders(event.target);
    initRevealAnimations(event.target);
    initProductForms(event.target);
    initProductGalleries(event.target);
    initAppearanceMode();
    updateWishlistCount();
  });

  document.addEventListener('click', function (event) {
    var themeToggle = event.target.closest('[data-fmv-theme-toggle]');
    if (themeToggle) {
      applyAppearanceMode(getNextAppearanceMode(document.body.dataset.fmvAppearance || getConfiguredAppearanceMode()));
      return;
    }

    var toggle = event.target.closest('[data-fmv-menu-toggle]');
    if (toggle) {
      openMobileMenu(toggle);
      return;
    }

    if (event.target.closest('[data-fmv-menu-close], [data-fmv-drawer-overlay], [data-fmv-wishlist-close]')) {
      closePanels();
      return;
    }

    if (event.target.closest('[data-fmv-wishlist-open]')) {
      openWishlist();
      return;
    }

    var wishlistToggle = event.target.closest('[data-fmv-wishlist-toggle]');
    if (wishlistToggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistToggle);
      return;
    }

    var wishlistRemove = event.target.closest('[data-fmv-wishlist-remove]');
    if (wishlistRemove) {
      saveWishlist(getWishlist().filter(function (item) { return item.id !== wishlistRemove.dataset.fmvWishlistRemove; }));
      updateWishlistCount();
      renderWishlist();
      return;
    }

    var wishlistCart = event.target.closest('[data-fmv-wishlist-cart]');
    if (wishlistCart) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(wishlistCart.dataset.fmvWishlistCart), quantity: 1 })
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {
        window.location.href = '/cart';
      });
      return;
    }

    if (event.target.closest('[data-fmv-size-chart-open]')) {
      var chart = document.querySelector('[data-fmv-size-chart]');
      if (chart) {
        chart.classList.add('is-open');
        chart.setAttribute('aria-hidden', 'false');
      }
      return;
    }

    if (event.target.closest('[data-fmv-size-chart-close]')) {
      var openChart = document.querySelector('[data-fmv-size-chart]');
      if (openChart) {
        openChart.classList.remove('is-open');
        openChart.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (event.target.closest('[data-fmv-share]')) {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
      }
      return;
    }

    var zoomButton = event.target.closest('[data-fmv-product-zoom]');
    if (zoomButton) {
      if (!zoomButton.classList.contains('is-active')) return;
      zoomButton.classList.toggle('is-zoomed');
      return;
    }

    var galleryThumb = event.target.closest('[data-fmv-gallery-thumb]');
    if (galleryThumb) {
      setGalleryIndex(galleryThumb.closest('[data-fmv-product-gallery]'), Number(galleryThumb.dataset.galleryIndex || 0));
      return;
    }

    var galleryPrev = event.target.closest('[data-fmv-gallery-prev]');
    if (galleryPrev) {
      var prevGallery = galleryPrev.closest('[data-fmv-product-gallery]');
      setGalleryIndex(prevGallery, Number(prevGallery.dataset.activeIndex || 0) - 1);
      return;
    }

    var galleryNext = event.target.closest('[data-fmv-gallery-next]');
    if (galleryNext) {
      var nextGallery = galleryNext.closest('[data-fmv-product-gallery]');
      setGalleryIndex(nextGallery, Number(nextGallery.dataset.activeIndex || 0) + 1);
      return;
    }

    var qtyButton = event.target.closest('[data-fmv-quantity-button]');
    if (qtyButton) {
      var wrapper = qtyButton.closest('[data-fmv-quantity]');
      var input = wrapper && wrapper.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var current = parseInt(input.value || String(min), 10);
      if (Number.isNaN(current)) current = min;
      var next = qtyButton.dataset.fmvQuantityButton === 'plus' ? current + 1 : Math.max(min, current - 1);
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var variantInput = event.target.closest('[data-fmv-variant-radio]');
    if (variantInput) {
      syncVariantState(variantInput);
      return;
    }

    var quantityInput = event.target.closest('[data-fmv-quantity] input');
    if (quantityInput) syncQuantityState(quantityInput);
  });

  document.addEventListener('input', function (event) {
    var quantityInput = event.target.closest('[data-fmv-quantity] input');
    if (quantityInput) syncQuantityState(quantityInput);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePanels();
      var chart = document.querySelector('[data-fmv-size-chart]');
      if (chart) {
        chart.classList.remove('is-open');
        chart.setAttribute('aria-hidden', 'true');
      }
    }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      var activeGallery = event.target.closest && event.target.closest('[data-fmv-product-gallery]');
      if (!activeGallery) return;
      event.preventDefault();
      setGalleryIndex(activeGallery, Number(activeGallery.dataset.activeIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
})();
